import React from "react";
import { Link } from "react-router-dom";

export default function MenuBar() {
  return (
    <header className="menu-bar">
      <div className="menu-inner">
        <Link className="menu-logo" to="/" aria-label="Sparkdenz home">
          <img src="/sparkdenz12.png" alt="Sparkdenz digital marketing agency logo" />
        </Link>
        <nav className="menu-links">
          <a href="/#services">Services</a>
          <Link to="/paid-search">Paid Search</Link>
          <Link to="/paid-social">Paid Social</Link>
          <Link to="/seo-service">SEO</Link>
          <Link to="/cro">CRO</Link>
          <Link to="/lifecycle-marketing">Lifecycle</Link>
          <a href="/#work">Work</a>
          <a href="/#about">About</a>
          <Link to="/contact-us">Contact</Link>
        </nav>
        <Link className="menu-cta" to="/contact-us">
          Book a Call
        </Link>
      </div>
    </header>
  );
}
